import { render, staticRenderFns } from "./FehlerView.vue?vue&type=template&id=40c2c3d7"
import script from "./FehlerView.vue?vue&type=script&lang=js"
export * from "./FehlerView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports